import { RouteHelper } from '@/helpers/Route'
import { ROUTE_INDEX_PERSONS, ROUTE_NAME_PERSONS } from '@/config/constants'
import {BasketHelper} from '@/helpers/Basket'

export default [
  {
    beforeEnter: (_to, from, next) => {
      const basket = RouteHelper.getBasket()
      const isStaticBasket = BasketHelper.isStaticBasket(basket)

      if (isStaticBasket) {
        if (from.name) {
          next(false)
        } else {
          next({
            name: RouteHelper.getNextRoute(basket),
          })
        }
      } else {
        next()
      }
    },
    component: () => import(/* webpackChunkName: "screen-person" */ '@/modules/Configurator/screens/Person.vue'),
    meta: {
      index: ROUTE_INDEX_PERSONS,
      secured: true,
    },
    name: ROUTE_NAME_PERSONS,
    path: '/persons',
  },
]
